module.exports = __webpack_public_path__ + "static/media/WedingBands.d4b37c50.png";